export const paths = {
	root: '/SnDrafts'
};